import { render, staticRenderFns } from "./BlockIndex.vue?vue&type=template&id=5c5e5a4b&scoped=true"
import script from "./BlockIndex.vue?vue&type=script&lang=js"
export * from "./BlockIndex.vue?vue&type=script&lang=js"
import style0 from "./BlockIndex.vue?vue&type=style&index=0&id=5c5e5a4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e5a4b",
  null
  
)

export default component.exports